/**
 * RESPONSIBILITY: show where you are and what is on screen, while developing.
 *
 * Off unless switched on at #/secret-flags, per browser. The framework always knows
 * this — see framework/react/location — this file only makes it visible.
 */
import {
  useAuth, useFlag, useHash, useActiveSection, useMountedSections, FLAG_DEV_BAR,
} from '@framework/react';

export function DevBar() {
  const enabled = useFlag(FLAG_DEV_BAR);
  const hash = useHash();
  const active = useActiveSection();
  const mounted = useMountedSections();
  const { session } = useAuth();

  if (!enabled) return null;

  return (
    <div className="dev-bar">
      <span className="dev-tag">flag</span>
      <span><b>route</b> {hash}</span>
      <span><b>in view</b> {active}</span>
      <span><b>mounted</b> {mounted.join(' · ') || '—'}</span>
      <span><b>as</b> {session ? session.roles.join(', ') || 'no roles' : 'anonymous'}</span>
    </div>
  );
}
